/**
 * Module devance
 * @module app.devance
 */
define([
    'angular',
    'moment',
    'bootstrap',
    'ui-bootstrap4',
    'angular-ui-notification',
    'angular-fr',
    'modules/devance/movements/index'
], function(angular, moment) {
    angular.module('app.devance', ['app.devance.movements']);
});
